const Tabs = {
  init() {
    // Attach click event to a parent element and use event delegation
    $(".bv-tab-heading").on("click", "li > a", function (e) {
      e.preventDefault();
      const $this = $(this);
      const id = $this.attr("href");

      // Remove active class from all tabs
      $this.closest("ul").find("li > a.active").removeClass("active");
      // Add active class to the clicked tab
      $this.addClass("active");

      // Hide all tab content except the target content
      $(id).siblings("div.active").removeClass("active").addClass("hide");
      // Show the target content
      $(id).removeClass("hide").addClass("active");
    });
  },

  reinit() {
    // Reinitialize event delegation
    $(".bv-tab-heading").off("click"); // Remove existing event handler
    this.init(); // Reattach event handler
  },
};

window.theme.Tabs = Tabs;

$(function () {
  window.theme.Tabs.reinit();
});
